<template>
  <div class="full" v-if="show">
    <img
      @click="handleClose"
      title="关闭"
      class="close"
      :src="src"
      style="width: 40px; height: 40px; z-index: 999"
    />
    <div
      style="
        overflow: scroll;
        z-index: 99999999999999999999999999;
        heigth: 100%;
        width: 100%;
      "
    >
      <iframe
        style="width: 100%; height: 100%; min-height: 1080px; min-width: 1920px"
        :src="url"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "full",
  data() {
    return {
      show: false,
      src: require("../../../static/img/close.png"),
    };
  },
  methods: {
    handleClose() {
      this.show = false;
      map3d_viewer.viewer.mouseHandlerManager.trigger("hidePopAndList", false);
    },
  },
  mounted() {
    map3d_viewer.viewer.mouseHandlerManager.listen("showFull", (config) => {
      this.show = true;
      this.url = config.url;
      map3d_viewer.viewer.mouseHandlerManager.trigger("hidePopAndList", true);
    });
  },
};
</script>


<style scoped>
.full {
  position: absolute;
  background: #01478d;
  height: 100%;
  width: 100%;
}
.close {
  color: white;
  position: absolute;
  left: 98%;
  cursor: pointer;
  top: 4%;
  height: 400px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background: transparent;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/full.vue